/** Update these values for your practice. */
export const practiceContact = {
    hours: [
        { label: 'Monday', value: '9am-12pm and 2:30pm-6pm' },
        { label: 'Tuesday', value: '9am-12pm and 2:30pm-6pm' },
        { label: 'Wednesday', value: '9am-12pm and 2:30pm-6pm' },
        { label: 'Thursday', value: '9am-12pm and 2:30pm-6pm' },
        { label: 'Friday', value: '9am-12pm and 2:30pm-6pm' },
        { label: 'Saturday', value: 'available by appointment' },
        { label: 'Sunday', value: 'available by appointment' },
    ],
    phone: '(513) 236-9017',
    phoneHref: 'tel:+15132369017',
    email: 'pecsokchiro@yahoo.com',
    addressLines: ['9902 Carver Road Suite 100', 'Blue Ash, OH 45242'],
    /**
     * Optional: paste the full iframe `src` from Google Maps → Share → Embed a map.
     * Leave empty to use a map generated from `addressLines`.
     */
    googleMapsEmbedSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12360.615492665114!2d-84.40166412651381!3d39.239378546446325!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884053b224054b97%3A0x6b007a170010eed!2s9902%20Carver%20Rd%20%23100%2C%20Blue%20Ash%2C%20OH%2045242!5e0!3m2!1sen!2sus!4v1781574131878!5m2!1sen!2sus',
};
